import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Wishlist from "@/pages/Wishlist";
import TrackOrder from "@/pages/TrackOrder";
import BrowseHub from "@/pages/BrowseHub";
import { BrowseColors, BrowseBudget } from "@/pages/BrowseSpecial";
import RoomLanding from "@/pages/RoomLanding";
import GiftFinder from "@/pages/GiftFinder";
import Inspiration from "@/pages/Inspiration";
import { Blog, BlogPost, CmsPage } from "@/pages/Content";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import { AdminCustomers, AdminCoupons } from "@/pages/admin/AdminMisc";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminBundles from "@/pages/admin/AdminBundles";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminHome from "@/pages/admin/AdminHome";
import AdminGiftFinder from "@/pages/admin/AdminGiftFinder";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminPages from "@/pages/admin/AdminPages";

import Bundles from "@/pages/Bundles";
import BundleDetail from "@/pages/BundleDetail";

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            {/* Storefront */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/category/:slug" element={<Shop />} />
              <Route path="/style/:slug" element={<Shop />} />
              <Route path="/material/:slug" element={<Shop />} />
              <Route path="/festival/:slug" element={<Shop />} />
              <Route path="/collection/:slug" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/track/:orderNumber" element={<TrackOrder />} />

              {/* Browse hubs */}
              <Route path="/rooms" element={<BrowseHub kind="room" />} />
              <Route path="/rooms/:slug" element={<RoomLanding />} />
              <Route path="/styles" element={<BrowseHub kind="style" />} />
              <Route path="/materials" element={<BrowseHub kind="material" />} />
              <Route path="/festivals" element={<BrowseHub kind="festival" />} />
              <Route path="/collections" element={<BrowseHub kind="collection" />} />
              <Route path="/colors" element={<BrowseColors />} />
              <Route path="/budget" element={<BrowseBudget />} />
              <Route path="/gift-finder" element={<GiftFinder />} />
              <Route path="/inspiration" element={<Inspiration />} />
              <Route path="/bundles" element={<Bundles />} />
              <Route path="/bundle/:slug" element={<BundleDetail />} />

              {/* Content */}
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/page/:slug" element={<CmsPage />} />
              <Route path="/contact" element={<Contact />} />

              {/* Account */}
              <Route path="/login" element={<Auth />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/account" element={<Account />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="bundles" element={<AdminBundles />} />
              <Route path="inventory" element={<AdminInventory />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="questions" element={<AdminQuestions />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="home" element={<AdminHome />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="pages" element={<AdminPages />} />
              <Route path="gift-finder" element={<AdminGiftFinder />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="activity" element={<AdminActivity />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </StoreProvider>
    </div>
  );
}

export default App;